// extracted by mini-css-extract-plugin
export default {"container":"Contant_container__y9tql"};